module.exports = __webpack_public_path__ + "img/house.e8e4f22a.jpg";